import * as Yup from 'yup';

export default () =>
	Yup.object().shape({
		email: Yup.string().email('Podaj poprawny adres email').required('Email jest wymagany'),
		password: Yup.string().min(6, 'Hasło jest za krótkie').required('Hasło jest wymagane')
	});
